module.exports = __webpack_public_path__ + "img/k20.702a467a.jpg";